import safetyMeetingParticipantTemplate from "./safety_meeting_participant.html";
import en from "./en.json";
import es from "./es.json";
import _ from "lodash";
import mixpanel from "mixpanel-browser";

import { CANCELLED, COMPLETE, PENDING } from "../../safety.constants";

class SafetyMeetingParticipantController {
    /* @ngInject */
    constructor($state, ToastService, $q) {
        this.$q = $q;
        this.$state = $state;
        this.ToastService = ToastService;
        this.expand = false;
        this.COMPLETE = COMPLETE;
        this.PENDING = PENDING;
        this.CANCELLED = CANCELLED;
    }

    cancel(status) {
        let ctrl = this;
        let requestCancellations = _.map(status.requests, function (request) {
            if (request.status === PENDING) {
                return request.cancel();
            }
        });
        ctrl.$q.all(requestCancellations).then(
            function (data) {
                mixpanel.track("Grower cancelled safety meeting request");
                ctrl.$state.reload();
            },
            function () {
                ctrl.ToastService.create(
                    "safetyMeetingParticipant.MARK_CANCELLED_FAILURE_TOAST",
                );
            },
        );
    }
}
export default {
    bindings: {
        status: "<",
        topics: "<",
    },
    controller: SafetyMeetingParticipantController,
    template: safetyMeetingParticipantTemplate,
    name: "safetyMeetingParticipant",
    translations: { en, es },
};
